import { register } from "async-ops";
import { callMvcApi } from "../../../../../call-web-api";
export const GET_STATUS_LOOKUP_LIST = "GET_STATUS_LOOKUP_LIST";

export const service = async (data) => {
  const options: object = {
    url: '/api/lookup/GetStatusLookupList/' + data.entity,
    method: "GET",
  };
  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(GET_STATUS_LOOKUP_LIST, service, mock);
